import classNames from 'classnames';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = Omit<ComponentProps<'div'>, 'children'>;

export function LazyFallback({ className, ...rest }: Props) {
  return (
    <div
      {...rest}
      className={classNames('d-flex flex-column align-items-center justify-content-center w-100 h-100', className)}
      data-e2e="loading-indicator"
    >
      <div className="spinner-border mb-2"></div>
      <FormattedMessage id="lazyLoading" />
    </div>
  );
}
